import { MobileDevice } from '@/types/Device'
import { getDevice } from './get-device'

export function isMobileDevice(device?: Awaited<ReturnType<typeof getDevice>>): device is MobileDevice {
  return !!device && (device.platform === 'android' || device.platform === 'ios')
}
